// LinkRenderer.tsx (Container)
export const URL_NORMALIZE_OPTIONS = {
  forceHttps: true,
  stripHash: true,
  stripTextFragment: true,
  removeQueryParameters: true,
  removeTrailingSlash: true,
  removeSingleSlash: true,
  removeExplicitPort: true,
} as const;
